import { render, staticRenderFns } from "./cbdManagePayees.vue?vue&type=template&id=7821e5e4"
import script from "./cbdManagePayees.vue?vue&type=script&lang=js"
export * from "./cbdManagePayees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7821e5e4')) {
      api.createRecord('7821e5e4', component.options)
    } else {
      api.reload('7821e5e4', component.options)
    }
    module.hot.accept("./cbdManagePayees.vue?vue&type=template&id=7821e5e4", function () {
      api.rerender('7821e5e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/cbdManagePayees.vue"
export default component.exports